/* Колонка «Исходник» — docs/ui-design.md §5.2 и §6.5, макет Main.html.
   Общий вид поля и панели кнопок задан классами .edbar/.edbtn/.edarea в styles/base.css;
   здесь только то, что появляется от превращения макетного <span>/<div> в живые
   <button>/<textarea>: сброс браузерных умолчаний и размеры. Ни одного цвета литералом. */

.head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spacer {
  flex: 1;
}

/* Кнопка вместо <span> из макета: браузер иначе нарисует свою рамку и свой шрифт. */
.tbtn {
  border: 0;
  background: none;
  font-family: inherit;
  cursor: pointer;
  padding: 0;
}

.tbtn:disabled {
  opacity: 0.45;
  cursor: default;
}

.area {
  display: block;
  width: 100%;
  box-sizing: border-box;
  min-height: 380px;
  resize: vertical;
}

.area:focus {
  outline: none;
  border-color: var(--violet);
}

/* Исходник версии, которую править нельзя: тот же вид, но текст не поле ввода. */
.frozen {
  white-space: pre-wrap;
  word-break: break-word;
  background: var(--bg-alt);
  color: var(--ink-2);
  border-radius: var(--r-ctl);
  min-height: 220px;
}

/* Позиция ошибки разбора — кнопка: клик ставит каретку в это место. */
.pos {
  font-family: var(--sans);
  font-variant-numeric: tabular-nums;
  font-size: 11px;
  border: 1px solid var(--border);
  background: var(--white);
  color: var(--ink-2);
  border-radius: var(--r-chip);
  padding: 1px 8px;
  margin-right: 6px;
  cursor: pointer;
  white-space: nowrap;
}

.pos:hover {
  border-color: var(--violet-bg-2);
  color: var(--accent-ink);
}

.saveRow {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  border-top: 1px solid var(--border-2);
  padding-top: 12px;
}

.changes {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.note {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--muted);
  font-size: 12.5px;
}

/* Счётчик и ⓘ «Каким сообщением уйдёт пост» — одной строкой: счётчик забирает ширину, ⓘ стоит
   у его первой строки. Объяснение в ⓘ, а не абзацем (правило партии §1). */
.meterRow {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.meterRow > :first-child {
  flex: 1 1 auto;
  min-width: 0;
}
